export default __webpack_public_path__ + "static/media/ProfielCover.46ff8ae8.jpg";